export default __webpack_public_path__ + "static/media/no_image_available.1edd6fd3.svg";